module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp12_8023.270643bf.png";